
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store/store'

import vuetify from '@/plugins/vuetify'
import './plugins/vuetify'
import './plugins/axios'
import './plugins/veeValidate'
import './plugins/v-mask'
import './plugins/vue-izitoast'
import './directives/v-formatMoney/';

import VuejsDialog from 'vuejs-dialog'
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import 'chartist/dist/chartist.min.css';

import './utilities/filters';
import Chartist from "chartist";

import PrevisulCotaMais from './previsul-theme';
import mgr from './services/security.js'

Vue.prototype.$Chartist = Chartist;

Vue.use(VuejsDialog);
Vue.use(PrevisulCotaMais);
Vue.config.productionTip = false;
//Vue.prototype.$vuetify = { rtl: false, lang: { current: 'pt'} };

const globalData = {
	isAuthenticated: false,
	user: '',
	mgr: mgr,
	Chartist: Chartist,
}

new Vue({
	vuetify,
	store,
	router,
	data: globalData,
	render: h => h(App),
}).$mount('#app')